import { UserProfile, UserProfileOverview } from "types";

import API from "./apiService";

export const getTeamOverviewForHighLevelLead = async (leadId: UserProfile["id"], timePeriod = 12): Promise<UserProfileOverview[]> => {
    const result = await API.get(`/History/teamOverviewForHighLevelLead/${leadId}/${timePeriod}`);
    return result.data;
}